
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersPolartwilight as ObiHeavySnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiHeavySnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-polartwilight',
   elementClass: ObiHeavySnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 